<template>
  <Layout>
    <div class="row">
      <div class="col-12 obj-instance-head">
        <h3>{{ $route.query.title }}</h3>
      </div>
    </div>
    <!-- 产品信息 -->
    <ObjModel
      v-model:selectedObjModel="selectedObjModel"
      :objModelInfo="objModelInfo"
      :isCheckForm="isCheckForm"
      @initInstanceDetail="initInstanceDetail"
      @selectedCurrentType="selectedCurrentType"
      @selectedObjModelIds="selectedObjModelIds"
    ></ObjModel>
    <!-- 物实例信息 -->
    <ObjInstance
      v-model:objInstance="objInstance"
      :isCheckForm="isCheckForm"
      :instanceError="instanceError"
    ></ObjInstance>

    <!-- 属性 -->
    <AttrData
      v-model:attrDataList="attrDataList"
      v-model:qrcodelist="qrcodelist"
      :productType="current_type"
      :customerid="customer_id"
      @getCustomerid="getCustomerid"
      :isCheckForm="isCheckForm"
    ></AttrData>

    <!-- 测量值 -->
    <MeasureData
      v-model:measureDataList="measureDataList"
      :isCheckForm="isCheckForm"
    ></MeasureData>

    <!-- 关联物实例 -->
    <RelationMeasure
      v-model:relationMeasureList="relationMeasureList"
      :isCheckForm="isCheckForm"
    ></RelationMeasure>

    <!-- 维护保养 -->
    <Repair
      v-model:repairs="repairs"
      :submitted="submitted"
      :editable="false"
    ></Repair>
    <!--故障知识库-->
    <FaultknowledgeBase
      :attrDataList="attrDataList"
      v-model:fault_knowledge="fault_knowledge"
      :measurements="measureDataList"
    ></FaultknowledgeBase>
    <Database v-model:files="files" @openAlert="openAlert"></Database>
    <!-- <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header d-flex align-items-center">
            <h4 class="card-title mb-0">{{ $t("历史电流数据导入") }}</h4>
            <div
              style="width: 150px"
              class="form-switch form-switch-left form-switch-md d-inline-flex accordion-button-class ms-4 align-items-center"
              @click="fileChange"
            >
              <input
                v-model="energy.is_upgrade"
                class="form-check-input code-switcher"
                type="checkbox"
                id="thumbnails-is-jigai"
                :disabled="
                  (energy &&
                    energy.files &&
                    energy.files.before &&
                    energy.files.before.length > 0) ||
                  (energy &&
                    energy.files &&
                    energy.files.after &&
                    energy.files.after.length > 0) ||
                  (energy &&
                    energy.files &&
                    energy.files.actual &&
                    energy.files.actual.length > 0)
                "
              />
              <label
                for="thumbnails-is-jigai"
                class="form-label text-muted m-0"
                >{{ $t("是否技改") }}</label
              >
            </div>
            <div v-if="energy && energy.is_upgrade">
              <el-radio-group v-model="upgrade_type">
                <el-radio class="m-0 d-flex align-items-center" :label="1">{{
                  $t("技改前")
                }}</el-radio>
                <el-radio
                  class="m-0 ms-2 d-flex align-items-center"
                  :label="2"
                  >{{ $t("技改后") }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="card-body pt-0">
            <equipment-database
              :upgrade_type="upgrade_type"
              :is_upgrade="energy.is_upgrade"
              :energy="energy"
              @energyChange="energyChange"
            ></equipment-database>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 标签 -->
    <TagData v-model:tagDataList="tagDataList"></TagData>

    <!-- 按钮区 -->
    <div class="text-end mt-3 mb-4">
      <b-button
        variant="outline-dark"
        size="md"
        class="waves-effect waves-light me-4"
        @click="handlerCancel()"
        style="min-width: 6rem"
        >{{ this.$t("base.cancel") }}</b-button
      >
      <!-- 编辑状态按钮 -->
      <b-button
        v-if="$route.query.type == 'edit'"
        variant="primary"
        size="md"
        class="btn btn-primary"
        @click="handlerSaveData()"
        style="min-width: 6rem"
        :disabled="submitLoading"
      >
        <b-spinner
          variant="light"
          style="width: 1rem; height: 1rem"
          v-show="submitLoading"
        ></b-spinner>
        <span v-show="!submitLoading">{{ this.$t("base.save") }}</span>
      </b-button>
      <!-- 创建状态按钮 -->
      <b-button
        v-else
        variant="primary"
        size="md"
        class="btn btn-primary"
        @click="handlerSaveData()"
        style="min-width: 6rem"
        :disabled="submitLoading"
      >
        <b-spinner
          variant="light"
          style="width: 1rem; height: 1rem"
          v-show="submitLoading"
        ></b-spinner>
        <span v-show="!submitLoading">{{
          this.$t("page.work-order.device.mkdev")
        }}</span>
      </b-button>
    </div>
    <MessageAlert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
    ></MessageAlert>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
// import PageHeader from "@/components/page-header";
import ObjModel from "@/views/asset/form/ObjModel";
import ObjInstance from "@/views/asset/form/ObjInstance";
import AttrData from "@/views/asset/form/AttrData";
import MeasureData from "@/views/asset/form/MeasureData";
import RelationMeasure from "@/views/asset/form/RelationMeasure";
import FaultknowledgeBase from "@/views/asset/form/FaultknowledgeBase";
import Database from "@/views/asset/form/Database";
import TagData from "@/views/asset/form/TagData";

import Repair from "@/views/asset/form/repair";

import MessageAlert from "@/components/common/MessageAlert";
import Swal from "sweetalert2";
import moment from "moment";
// import { attributes} from "@/utils/selectText.js"
import _ from "lodash";
import {
  getModelList,
  getModelsList,
  getInstancesList,
  getInstanceDetail,
  createInstance,
  editInstance,
  getModelDetailId,
  exportInstancesMeasurements,
} from "@/service/index";
// import EquipmentDatabase from "@/views/asset/form/equipmentDatabase.vue";
import { errorMsg } from "@/helpers/swal";

export default {
  name: "Modals",
  data() {
    return {
      upgrade_type: 1,
      energy: {
        is_upgrade: false,
        files: {},
      },
      /* 面包屑 */
      PageHeaderT: this.$t("page.work-order.device.text"),
      PageHeaderItems: [
        {
          text: this.$t("menu.equipment-management.model-management.text"),
        },
        {
          text: this.$t("page.work-order.device.text"),
          active: true,
          href: "/asset",
        },
        {
          text: this.$route.query.title,
          active: true,
        },
      ],
      isCheckForm: false,
      /* 产品信息 */
      objModelInfo: [],
      selectedObjModel: "",
      current_type: null,
      selectedObjModelId: "",
      /*物实例信息 */
      objInstance: {},
      instance_id: "",
      instanceError: false,
      /* 属性 */
      attrDataList: [],
      /* 测量值 */
      measureDataList: [],
      /* 维护保养 */
      repairs: [],
      /* 关联物实例 */
      relationMeasureList: [],
      fault_knowledge: [],

      relationForm: null,
      relationMeasureOption: [],
      relationMeasureOptionHasMore: true,
      /* 资料库 */
      files: { image: [], video: [], document: [] },
      /* 标签 */
      tagDataList: [],
      tagForm: null,
      submitLoading: false,
      submitted: false,
      formValidataAlert: false,
      alertInfo: {
        variant: "danger",
        content: this.$t("page.form_verification_failed"),
        icon: "ri-error-warning-line",
      },
      //测量值列表
      measurements: [],
      qrcodelist: [],
      product_list: [],
      customer_id: "",
      service_company_id: "",
      // 获取关联设备的参数
      getInstancesListParam: {
        product_type: "1",
        keyword: "",
        page: 1,
        page_size: 10,
      },
    };
  },
  components: {
    // EquipmentDatabase,
    Layout,
    // PageHeader,
    ObjModel,
    ObjInstance,
    AttrData,
    MeasureData,
    RelationMeasure,
    Database,
    TagData,
    Repair,
    MessageAlert,
    FaultknowledgeBase,
  },
  watch: {
    // selectedObjModel: {
    //   handler(val) {
    //     if (this.$route.query.type == "create") {
    //       this.objId = this.$route.query.model_id;
    //       if (this.objModelInfo) {
    //         this.objModelInfo.forEach((obj) => {
    //           if (obj.name == val) {
    //             this.objId = obj.id;
    //           }
    //         });
    //       }
    //       if (this.objId) this.initInstanceDetail({ id: this.objId });
    //     }
    //   },
    // },
  },
  mounted() {
    this.initModelsList();
    // this.getExportInstancesMeasurements();

    /* hanlder编辑物实例 */
    if (this.$route.query.type == "edit" && this.$route.query.instance_id) {
      /* ------- todo 换成传过来的物实例id -------  */
      this.eidtInstance(this.$route.query.instance_id);
    }
  },
  methods: {
    fileChange() {
      if (
        (this.energy &&
          this.energy.files &&
          this.energy.files.before &&
          this.energy.files.before.length > 0) ||
        (this.energy &&
          this.energy.files &&
          this.energy.files.after &&
          this.energy.files.after.length > 0) ||
        (this.energy &&
          this.energy.files &&
          this.energy.files.actual &&
          this.energy.files.actual.length > 0)
      ) {
        errorMsg("请先删除历史数据！");
      }
    },
    energyChange(item) {
      this.energy.files = item;
    },
    getCustomerid(data) {
      if ("customer_id" in data) {
        this.customer_id = data.customer_id;
      }
      if ("service_company_id" in data) {
        this.service_company_id = data.service_company_id;
      }
    },
    selectedObjModelIds(id, ide) {
      this.objId = id;
      this.product_list = ide;
      if (this.product_list.length > 0) {
        /* 当选择设备型号时，属性列表对应型号默认显示 */
        this.attrDataList.length &&
          this.attrDataList.forEach((item) => {
            if (item.group === "设备出厂信息") {
              item.list.forEach((item_c) => {
                if (
                  item_c.group === "设备出厂信息" &&
                  item_c.name === "设备型号"
                ) {
                  item_c.value =
                    this.product_list[this.product_list.length - 1];
                  return;
                }
              });
            }
          });
      }
      this.initInstanceDetail({ id: id });
    },
    selectedCurrentType(type) {
      this.current_type = type;
      this.initModelList(type);
    },
    initModelList(type) {
      getModelList({ type: type }).then((res) => {
        if (res && res.payload && res.payload.data) {
          if (res && res.payload && res.payload.data) {
            this.objModelInfo = res.payload.data;
          }
        }
      });
    },
    filterGroupAttr(arr) {
      var map = {},
        dest = [];
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];
        if (!map[ai.group]) {
          dest.push({
            group: ai.group,
            list: [ai],
          });
          map[ai.group] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj.group == ai.group) {
              dj.list.push(ai);
              break;
            }
          }
        }
      }
      return dest;
    },
    filterAttribute(data) {
      let result = [];
      data.forEach((Item) => {
        var group = Item.group;
        Item.list.forEach((item) => {
          result.push({ ...item, group });
        });
      });
      return result;
    },
    //   获取测量值列表
    getExportInstancesMeasurements() {
      exportInstancesMeasurements()
        .then((res) => {
          if (res.payload.measurements) {
            this.measurements = res.payload.measurements;
            if (this.measureDataList.length) {
              this.measureDataList.map((items) => {
                this.measurements.map((item, i) => {
                  if (items.alias == item) {
                    this.measurements.splice(i, 1);
                  }
                });
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /* 获取 产品|物实例 「下拉选项列表」 */
    initModelsList() {
      /* 产品列表 */
      getModelsList()
        .then((res) => {
          if (res && res.payload && res.payload.data) {
            this.objModelInfo = res.payload.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      /* 物实例列表 */

      // console.log('初始化获取列表....')
      // this.getRelationInstancesList();
    },
    getRelationInstancesList(searchVal) {
      if (searchVal) {
        this.getInstancesListParam = {
          ...this.getInstancesListParam,
          ...searchVal,
        };
      }
      getInstancesList(this.getInstancesListParam)
        .then((res) => {
          var inumList = JSON.parse(localStorage.getItem("inumList"));
          var isIndex = this.$route.query.layer_num;
          localStorage.setItem("layer_num", isIndex);
          var parId = localStorage.getItem("parId");
          if (res && res.payload && res.payload.data) {
            if (this.getInstancesListParam.page == 1) {
              this.relationMeasureOption = res.payload.data;
            } else {
              this.relationMeasureOption = this.relationMeasureOption.concat(
                res.payload.data
              );
            }

            if (this.relationMeasureOption.length >= res.payload.count) {
              this.relationMeasureOptionHasMore = false;
            } else {
              this.relationMeasureOptionHasMore = true;
            }

            this.relationMeasureOption.forEach((rel) => {
              rel.label = rel.name;
              rel.value = rel.id;
              rel.disabled = rel.has_parent;
              if (parId == rel.id) {
                rel.disabled = true;
              }
              //关联实例不能大于五层
              if (inumList && isIndex) {
                inumList.map((item) => {
                  var nums = Number(item[rel.name]) + Number(isIndex);
                  if (item[rel.name] && Number(nums) > 5) {
                    rel.disabled = true;
                  }
                });
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /* 获取当前产品下 -- 新建物实例信息 */
    initInstanceDetail(params) {
      getModelDetailId(params)
        .then((res) => {
          if (res && res.payload) {
            this.selectedObjModel = res.payload.name || ""; //当前产品
            this.customer_id = res.payload.customer_id || "";
            this.service_company_id = res.payload.service_company_id || "";
            this.qrcodelist = [];
            let attrDataList = res.payload.attributes.attributes; //属性
            attrDataList.forEach((attr) => {
              if (this.$route.query.type === "create") {
                attr["owner"] = "inherit";
              }
              attr.value = attr.default;
              attr["dataValidation"] = {
                type: false,
                typeError: "",
              };
              attr["updateTime"] = moment().format("YYYY-MM-DD HH:mm:ss");
              delete attr.default;
              if (attr.group === "设备出厂信息") {
                //二维码做标记
                if (attr.qrcodeChecked === undefined) attr.qrcodeChecked = true;
                this.qrcodelist.push(attr);
              }
              if (attr.name === "质保到期时间") {
                if (
                  (attr.value === "Invalid date" || attr.value === "") &&
                  attrDataList.filter((item) => {
                    return item.name === "发货时间";
                  }).length > 0
                ) {
                  attr.value = moment(
                    attrDataList.filter((item) => {
                      return item.name === "发货时间";
                    })[0].value
                  )
                    .add(1, "years")
                    .format("YYYY/MM/DD");
                }
              }
              //客户名称
              if (attr.group == "商务信息" && attr.name == "客户名称") {
                attr.value = res.payload.customer_txt;
              }
            });
            this.attrDataList = this.filterGroupAttr(attrDataList);

            if (this.product_list.length > 0) {
              /* 当选择设备型号时，属性列表对应型号默认显示 */
              this.attrDataList.length &&
                this.attrDataList.forEach((item) => {
                  if (item.group === "设备出厂信息") {
                    item.list.forEach((item_c) => {
                      if (
                        item_c.group === "设备出厂信息" &&
                        item_c.name === "设备型号"
                      ) {
                        item_c.value =
                          this.product_list[this.product_list.length - 1];
                        return;
                      }
                    });
                  }
                });
            }
            this.files = res.payload.files;
            //需要继承父级file的文件设置为继承属性，relation_type: inherit继承/self非继承*/
            for (let obj in this.files) {
              if (this.files[obj].length) {
                this.files[obj].forEach((item) => {
                  item.relation_type = "inherit";
                });
              }
            }

            Object.values(this.files).forEach((file) => {
              if (file.length > 0) {
                file.forEach((item) => {
                  if (this.$route.query.type != "edit") {
                    item.disabled = true;
                  } else {
                    if (item.relation_type == "inherit") {
                      item.disabled = true;
                    } else {
                      item.disabled = false;
                    }
                  }
                });
              }
            });

            this.energy = {
              is_upgrade:
                (res.payload.energy && res.payload.energy.is_upgrade) || false,
              files: (res.payload.energy && res.payload.energy.files) || {},
            };

            this.fault_knowledge =
              _.get(res, ["payload", "fault_knowledge"]) || [];
            this.repairs = res.payload.repairs || [];

            this.measureDataList =
              (res.payload.attributes && res.payload.attributes.measurements) ||
              []; //测量值
            this.measureDataList.forEach((measure) => {
              if (this.$route.query.type == "create") {
                measure["owner"] = "inherit";
              }
              measure["meatype"] = false;
              measure["distype"] = false;
              measure.alias = ""; //别名
              measure.recordThreshold = false; //阀值开关
              measure.operationThresholdHigh = ""; //可运行（高
              measure.operationThresholdLow = ""; //可运行（低
              measure.standardThresholdHigh = ""; //理想（高
              measure.standardThresholdLow = ""; //理想（低

              if (measure.is_show === undefined) {
                //如果没有给一个默认的值
                measure.is_show = true; //是否展示
              }
            });
            if (res.payload.extra_info.relationMeasureList) {
              res.payload.extra_info.relationMeasureList.forEach((val) => {
                if(val.attributes){
                  this.relationMeasureList.push({
                  id: val.id,
                  value: val.id,
                  label: val.name + "(" + val.root_sn + ")",
                  name: val.name,
                  root_sn: val.root_sn,
                  disabled: true,
                  type: this.$route.query.type,
                });
                }else{
                  this.relationMeasureList.push({...val})
                }
               
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /* hanlder编辑，获取物实例详情 */
    eidtInstance(id) {
      getInstanceDetail(id)
        .then((res) => {
          if (res && res.payload) {
            this.isCheckForm = true;
            this.current_type = res.payload.product_type;
            this.product_list = _.get(res.payload, [
              "extra_info",
              "product_list",
            ]);
            this.customer_id = res.payload.customer_id || null;
            this.service_company_id = res.payload.service_company_id || null;
            this.selectedObjModel = res.payload.deviceProfileName || ""; //当前产品
            this.objId = res.payload.deviceProfileId; //当前产品id
            this.objInstance = {
              instance: res.payload.name || "",
              is_iot_ready: res.payload.is_iot_ready,
            }; //当前物实例
            this.instance_id = res.payload.id || ""; //当前物实例id
            this.files = res.payload.files;
            this.energy = {
              is_upgrade:
                (res.payload.energy && res.payload.energy.is_upgrade) || false,
              files: (res.payload.energy && res.payload.energy.files) || {},
            };
            this.fault_knowledge =
              _.get(res, ["payload", "fault_knowledge"]) || [];
            this.repairs = res.payload.repairs || [];
            let qrcodeCheckedList = res.payload.extra_info.qrcodeCheckedList;
            this.qrcodelist = [];
            let attrDataList = res.payload.attributes.attributes; //属性
            attrDataList.forEach((attr) => {
              attr["dataValidation"] = {
                type: false,
                typeError: "",
              };
              attr["updateTime"] = moment().format("YYYY-MM-DD HH:mm:ss");
              delete attr.default;
              if (attr.group == "设备出厂信息") {
                attr.qrcodeChecked = qrcodeCheckedList
                  ? qrcodeCheckedList.includes(attr.id)
                  : true;
                this.qrcodelist.push(attr);
              }
              if (attr.name === "质保到期时间") {
                if (
                  (attr.value === "Invalid date" || attr.value === "") &&
                  attrDataList.filter((item) => {
                    return item.name === "发货时间";
                  }).length > 0
                ) {
                  attr.value = moment(
                    attrDataList.filter((item) => {
                      return item.name === "发货时间";
                    })[0].value
                  )
                    .add(1, "years")
                    .format("YYYY/MM/DD");
                }
              }
              if (attr.name === "维保服务商" && attr.owner === "inherit") {
                attr.value = res.payload.service_company_txt || null;
              }
              //客户名称
              if (attr.group == "商务信息" && attr.name == "客户名称") {
                attr.value = res.payload.customer_txt;
              }
            });
            this.attrDataList = this.filterGroupAttr(attrDataList);
            // this.attrDataList = this.filterGroupAttr(res.payload.attributes.attributes)

            /* 当选择设备型号时，属性列表对应型号默认显示 */
            if (this.selectedObjModel) {
              this.attrDataList.length &&
                this.attrDataList.forEach((item) => {
                  if (item.group === "设备出厂信息") {
                    item.list.forEach((item_c) => {
                      if (
                        item_c.group === "设备出厂信息" &&
                        item_c.name === "设备型号" &&
                        !item_c.value
                      ) {
                        item_c.value = this.selectedObjModel;
                        return;
                      }
                    });
                  }
                });
            }
            this.measureDataList =
              (res.payload.attributes && res.payload.attributes.measurements) ||
              []; //测量值
            this.measureDataList.forEach((measure) => {
              if (measure.is_show === undefined) {
                //如果没有给一个默认的值
                measure.is_show = true; //是否展示
              }
            });
            if (res.payload.extra_info.relationMeasureList) {
              res.payload.extra_info.relationMeasureList.forEach((val) => {
                if(val.attributes){
                  this.relationMeasureList.push({
                  id: val.id,
                  value: val.id,
                  label: val.name + "(" + val.root_sn + ")",
                  name: val.name,
                  root_sn: val.root_sn,
                  disabled: true,
                  type: this.$route.query.type,
                });
                }else{
                  this.relationMeasureList.push({...val})
                }
               
              });
            }
            this.tagDataList = res.payload.tags || []; //标签
            // this.getExportInstancesMeasurements();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /* 页面级取消 */
    handlerCancel() {
      if (this.$route.query.type == "edit" && this.$route.query.model_id) {
        this.$router.push(`/asset?asset_id=${this.instance_id}`);
      } else {
        this.$router.go(-1);
      }
    },
    isNumber(val) {
      return !isNaN(Number(val));
    },
    /* 保存编辑物实例 */
    handlerSaveData() {
      this.submitted = true;
      if (!this.checkFormValue()) {
        this.openAlert(null, false);
        return;
      }
      Swal.fire({
        title: this.$t("page.submitting"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      this.submitLoading = true;
      this.instanceError = false;
      let attrDataList = this.filterAttribute(this.attrDataList);
      let measureDataList = this.measureDataList;
      let qrcodeCheckedList = [];
      attrDataList &&
        attrDataList.map((item) => {
          if (item.dtype == "number" || item.dtype == "float") {
            if (this.isNumber(item.value)) {
              item.value = Number(item.value);
            }
          }
          if (item.dtype == "boolean") {
            if (item.value == "false") {
              item.value = false;
            } else if (item.value == "true") {
              item.value = true;
            }
          }
          if (item["dataValidation"]) {
            delete item["dataValidation"];
          }
          if (item.group === "设备出厂信息") {
            this.qrcodelist.map((code) => {
              if (code.qrcodeChecked) qrcodeCheckedList.push(code.id);
            });
          }
        });
      measureDataList &&
        measureDataList.map((item) => {
          if (!item.recordThreshold) {
            item.standardThresholdLow = "";
            item.standardThresholdHigh = "";
            item.operationThresholdHigh = "";
            item.operationThresholdLow = "";
          }
        });
      let params = {
        name: this.objInstance.instance,
        is_iot_ready: this.objInstance.is_iot_ready,
        model_id: this.objId,
        attributes: JSON.stringify({
          attributes: attrDataList,
          measurements: measureDataList,
        }),
        tags: JSON.stringify(this.tagForm),
        files: JSON.stringify(this.files),
        repairs: JSON.stringify(this.repairs),
        children: JSON.stringify(this.relationForm),
        product_type: this.current_type,
        customer_id: this.customer_id,
        fault_knowledge: JSON.stringify(this.fault_knowledge),
        service_company_id: this.service_company_id,
        energy: JSON.stringify(this.energy),
        extra_info: {
          qrcodeCheckedList,
          relationMeasureList: this.relationMeasureList,
          product_list: this.product_list,
          relationSns: this.relationForm.map((item) => item.root_sn),
        },
      };
      if (this.$route.query.type == "edit") {
        //编辑

        /* todo保存实例接口 */
        editInstance(this.instance_id, params)
          .then(() => {
            // this.submitLoading = false;
            Swal.close();
            let msgInfo = {
              variant: "success",
              content: this.$t("page.edit_success"),
              icon: "ri-check-double-line",
            };
            this.openAlert(msgInfo, true);
          })
          .catch((err) => {
            Swal.close();
            this.submitLoading = false;
            if (err.message) {
              Swal.close();
              var info = {
                variant: "danger",
                content: this.$t(err.message),
                icon: "ri-error-warning-line",
              };
              this.openAlert(info, false);
            } else {
              let msgInfo = {
                variant: "danger",
                content: this.$t("page.sava_fail") + err,
                icon: "ri-error-warning-line",
              };
              this.openAlert(msgInfo, false);
            }
          });
      } else {
        //创建

        /* todo创建物实例接口 params*/
        createInstance(params)
          .then((res) => {
            this.instance_id = res.payload.id;
            Swal.close();

            let msgInfo = {
              variant: "success",
              content: this.$t("page.device_create_success"),
              icon: "ri-check-double-line",
            };
            this.openAlert(msgInfo, true);
          })
          .catch((err) => {
            this.submitLoading = false;
            if (err.message) {
              Swal.close();
              var info = {
                variant: "danger",
                content: this.$t(err.message),
                icon: "ri-error-warning-line",
              };
              this.openAlert(info, false);
            } else {
              Swal.close();
              let msgInfo = {
                variant: "danger",
                content: this.$t("page.create_fail") + err,
                icon: "ri-error-warning-line",
              };
              this.openAlert(msgInfo, false);
            }
          });
      }
    },
    isRepeat(arr, key) {
      let names = arr.map((item) => item[key]);
      let nameSet = new Set(names);
      return nameSet.size == names.length;
    },
    /* 提交表单验证  */
    checkFormValue() {
      let cheackState = true;
      this.isCheckForm = true;
      /* 产品 ｜ 物实例值 筛选 */
      if (!this.selectedObjModel) {
        this.alertInfo.content = this.$t("page.product_name_cannot_null");
        cheackState = false;
        window.scrollTo(0, 88);
      }
      if (!this.objInstance.instance) {
        if (cheackState) window.scrollTo(0, 340);
        this.alertInfo.content = this.$t("page.device_name_cannot_null");
        cheackState = false;
      }

      if (this.attrDataList) {
        this.attrDataList.map((Item) => {
          Item.list.map((item) => {
            // if (this.$route.query.type == "create") {
            //   item["owner"] = "inherit";
            // }
            item["dataValidation"] = {
              type: false,
              typeError: "",
            };
            if (item.required && (!item.value || item.value.length == 0)) {
              if (cheackState) window.scrollTo(0, 510);
              cheackState = false;
            }
            if (item.dtype == "float" && item.value != "") {
              if (
                !(
                  this.isNumber(item.value) &&
                  /^(-?\d+)(\.\d+)?$/.test(Number(item.value))
                )
              ) {
                item["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.value_must_double_precision_number"),
                };
                cheackState = false;
                this.alertInfo.content = this.$t(
                  "page.data_type_double_default_value_fail"
                );
              }
            }

            if (item.dtype == "number" && item.value != "") {
              if (
                !(
                  this.isNumber(item.value) &&
                  /^-?\d+$/.test(Number(item.value))
                )
              ) {
                item["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.must_be_integer"),
                };
                cheackState = false;
                this.alertInfo.content = this.$t(
                  "page.data_type_integer_default_value_fail"
                );
              }
            }

            if (item.dtype == "boolean" && item.value != "") {
              item.value = item.value.toString();
              if (item.value != "false" && item.value != "true") {
                item["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.input_true_or_false"),
                };
                cheackState = false;
                this.alertInfo.content = this.$t(
                  "page.data_type_bool_default_value_fail"
                );
              }
            }
          });
        });
      }

      /* 测量值筛选 */
      if (this.measureDataList) {
        this.measureDataList &&
          this.measureDataList.map((mea) => {
            mea["distype"] = false;
            if (
              mea.recordThreshold &&
              (mea.operationThresholdHigh.length == 0 ||
                mea.operationThresholdLow.length == 0 ||
                mea.standardThresholdHigh.length == 0 ||
                mea.standardThresholdLow.length == 0)
            ) {
              mea["meatype"] = true;
              this.alertInfo.content = this.$t(
                "page.tending_threshold_range_cannot_be_empty"
              );
            }
            mea["dataValidation"] = {
              type: false,
              typeError: this.$t("page.duplicate_alias"),
            };
            this.measurements.map((item) => {
              if (mea.alias == item) {
                mea["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.duplicate_alias"),
                };
                cheackState = false;
                this.alertInfo.content = this.$t(
                  "page.tending_duplicate_alias"
                );
              }
            });
            if (
              mea.recordThreshold &&
              (!String(mea.operationThresholdHigh) ||
                !String(mea.operationThresholdLow) ||
                !String(mea.standardThresholdHigh) ||
                !String(mea.standardThresholdLow))
            ) {
              mea["distype"] = true;
              cheackState = false;
            }
          });
      }

      // 维护保养定义表单检测
      if (this.repairs.length) {
        for (let i = 0; i < this.repairs.length; i++) {
          if (this.repairs[i].is_deleted) continue;
          if (this.repairs[i].item_name) {
            if (this.repairs[i].item_name.length > 50) {
              this.alertInfo.content = this.$t(
                "page.maintenance_item_name_cannot_exceed"
              );
              cheackState = false;
              break;
            }
          } else {
            this.alertInfo.content = this.$t(
              "page.maintenance_item_name_cannot_empty"
            );
            cheackState = false;
            break;
          }
          if (!this.repairs[i].name) {
            this.alertInfo.content = this.$t(
              "page.maintenance_name_cannot_empty"
            );
            cheackState = false;
            break;
          }
          if (!this.repairs[i].cycle) {
            this.alertInfo.content = this.$t(
              "page.maintenance_period_cannot_empty"
            );
            cheackState = false;
            break;
          }
        }
        // if (!this.isRepeat(this.repairs.filter(item => !item.is_deleted), "item_name")) {
        //   this.alertInfo.content = this.$t('page.maintenance_item_name_must_unique');
        //   cheackState = false;
        // }
        // 判断相同的维护保养名称是否有不同的维护周期
        if (
          this.repairs.some((item, index, arr) => {
            return (
              arr.findIndex(
                (other) =>
                  !other.is_deleted &&
                  other.name == item.name &&
                  other.cycle != item.cycle
              ) !== -1
            );
          })
        ) {
          this.alertInfo.content = this.$t(
            "page.maintenance_item_name_must_same_cycle"
          );
          cheackState = false;
        }
      }

      /* 关联物实例空值筛选 */
      if (this.relationMeasureList) {
        this.relationForm = this.relationMeasureList.filter((attr) => {
          return attr.name;
        });
      }

      /* 标签空值筛选 */
      if (this.tagDataList) {
        this.tagForm = this.tagDataList.filter((attr) => {
          return attr.key || attr.value;
        });
      }

      return cheackState;
    },
    /* 消息提示框 */
    openAlert(info, needJump) {
      if (info) {
        this.alertInfo = info;
      }
      this.formValidataAlert = true;
      this.isCheckForm = true;
      setTimeout(
        () => {
          this.formValidataAlert = false;
          if (needJump) {
            // this.$router.push(`/asset?asset_id=${this.instance_id}`);
            if (this.$route.query.source === "equipment-detail-associated") {
              // 从设备详情的关联列表中点编辑跳转过来的，直接返回上一页
              this.$router.go(-1);
            } else {
              this.$router.push(
                `/equipment-detail?equip_id=${this.instance_id}`
              );
            }

            this.submitLoading = false;
          }
        },
        needJump ? 1000 : 5000
      );
    },
  },
};
</script>

<style>
.obj-instance-head {
  padding: 1rem 1rem 1rem;
}

.must-input {
  color: #f06548;
}

.table-content-row {
  margin-bottom: 28px;
}

.addButton {
  text-align: center;
  margin-top: 24px;
}
</style>
